<template>
  <div class="List">
    <van-nav-bar
      title="联系人"
      fixed
      placeholder
      :z-index="10"
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        class="list-box"
      >
        <RelationtItem
          v-for="(item, index) in list"
          isShowRadio
          :item="item"
          :key="index"
          class="item"
          @change="$set(item, 'checked', !item.checked)"
        ></RelationtItem>
      </van-list>
    </van-pull-refresh>
    <div class="bottom-btn">
      <div class="btns">
        <van-button
          round
          block
          type="info"
          @click="selectRelation"
          native-type="submit"
          >确认选择</van-button
        >
        <van-button
          round
          block
          type="info"
          @click="addRelation"
          native-type="submit"
          >新增联系人</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Search } from "vant";
import { Icon } from "vant";
import { Tabbar, TabbarItem } from "vant";
import Vue from "vue";
import Api from "@/api/user";
// import { eventBus } from "@/plugins/common.js";
Vue.use(Search, Icon, Tabbar, TabbarItem);
import { mapMutations } from "vuex";

import { Toast } from "vant";
export default {
  props: {},
  components: {
    RelationtItem: () => import("./RelationtItem.vue"),
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      filter: {
        customerId: this.$route.query.customerId,
        name: this.$route.query.name,
      },
      pageNo: 1,
      pageSize: 10,
    };
  },
  methods: {
    ...mapMutations(['setRelationList']),
    onSearch() {
      this.pageNo = 1;
      this.list = [];
      this.onLoad();
    },
    onSerachClick() {
      this.$router.push({
        name: "search",
      });
    },
    async onLoad() {
      try {
        this.finished = false;
        this.loading = true;
        const { pageNo, pageSize, filter } = this;
        const params = {
          pageNo,
          pageSize,
          customerId: filter.customerId,
        };
        var res = await Api.getContactsList(params);
        const { data } = res;
        const { list } = data;
        if (this.pageNo == 1) {
          this.list = list;
        } else {
          this.list = [...this.list, ...list];
        }
        this.finished = !data.isNextPage;
        this.pageNo++;
      } catch (error) {
        Toast.fail(error);
        // this.list = [];
        this.finished = true;
      } finally {
        this.loading = false;
        this.refreshing = false;
      }
    },
    onRefresh() {
      this.pageNo = 1;
      this.onLoad();
    },
    selectRelation() {
      const list = this.list.filter((item) => item.checked);
      if (list.length == 0) {
        Toast.fail("请选择联系人");
        return;
      }
      // eventBus.$emit("message-sent", list);
      this.setRelationList(list);
      this.$router.back();
    },

    addRelation() {
      this.$router.push({
        path: "/relation/create",
        query: this.filter,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.List {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.van-tabs {
  /deep/ .van-tabs__line {
    background: #3c86ff !important;
    height: 2px !important;
    width: 4em !important;
  }
}

.list-box {
  padding: 10px 12px;

  .item {
    margin-bottom: 15px;
  }
}
</style>
